import { render, staticRenderFns } from "./GetElderly.vue?vue&type=template&id=6286fc38&scoped=true&"
import script from "./GetElderly.vue?vue&type=script&lang=js&"
export * from "./GetElderly.vue?vue&type=script&lang=js&"
import style0 from "./GetElderly.vue?vue&type=style&index=0&id=6286fc38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6286fc38",
  null
  
)

export default component.exports